import React from 'react';
import { Button } from 'react-bootstrap';
import { Comparison } from 'helper/products/meteorology';
import useSetComparison from 'utils/hooks/meteorology/comparator/useSetComparison';
import { useDispatch, useSelector } from 'react-redux';
import {
  setTriggerActivity,
  selectMFComparatorControlPanelTitle,
  selectMFComparatorControlPanelSubtitle,
} from 'redux/reducers/meteorologyFieldsComparatorControlPanelReducer';

export const POPULAR_COMPARISONS_TITLE = 'Comparações Populares';

export default function PopularComparison({ comparison }: { comparison: Comparison }) {
  const dispatch = useDispatch();
  const setComparison = useSetComparison();

  // O par title/subtitle e gravado pelo proprio setComparison e zerado quando o
  // usuario mexe num modelo a mao, entao serve de estado de selecao sem exigir
  // nada novo no reducer. O title distingue esta lista das Preferencias
  // Salvas, que podem ter uma comparacao de mesmo nome.
  const title = useSelector(selectMFComparatorControlPanelTitle);
  const subtitle = useSelector(selectMFComparatorControlPanelSubtitle);
  const isSelected = title === POPULAR_COMPARISONS_TITLE && subtitle === comparison.name;

  const loadPreference = () => {
    setComparison(comparison, POPULAR_COMPARISONS_TITLE);
    dispatch(setTriggerActivity(true));
  };

  return (
    <div>
      <Button
        variant="link"
        onClick={loadPreference}
        className={`btn-control-panel text-truncate ${isSelected ? 'btn-control-panel-active' : ''}`}
        title={comparison.name}
        aria-pressed={isSelected}
      >
        {comparison.name}
      </Button>
    </div>
  );
}
